import { ApolloClient, from } from "@apollo/client";

import { authMiddleware, cache, errorMiddleWare, getHttpLink, getRestLink } from "./";

const emptyArr = [];

export const getUnauthLink = ({
  middlewares = emptyArr,
  defaultUri,
  endpoints,
  customHeaders,
  restEndpoint,
}) =>
  from([
    ...middlewares,
    errorMiddleWare,
    getRestLink({ customHeaders, restEndpoint }),
    getHttpLink({ default: defaultUri, endpoints, customHeaders }),
  ]);

export const getApolloAuthLink = ({
  middlewares = emptyArr,
  token,
  defaultUri,
  endpoints,
  customHeaders,
  restEndpoint,
}) =>
  from([
    authMiddleware(token),
    ...middlewares,
    errorMiddleWare,
    getRestLink({ customHeaders, restEndpoint }),
    getHttpLink({ default: defaultUri, endpoints, customHeaders }),
  ]);

export const getClient = (() => {
  let client = null;
  return (clientOptions) => {
    const { defaultUri, endpoints, customHeaders, restEndpoint } = clientOptions;
    if (!client) {
      client = new ApolloClient({
        cache,
        connectToDevTools: true,
        link: getUnauthLink({ defaultUri, endpoints, customHeaders, restEndpoint }),
      });
    }
    return client;
  };
})();
